"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { ui } from "@clerk/ui";
import type { ReactNode } from "react";

import { isNativeCapacitorApp } from "@/lib/client/capacitor";

const appearance = {
  options: {
    logoImageUrl: "/kurb-blue.png",
    logoLinkUrl: "/",
  },
};

const localization = {
  signIn: {
    start: {
      title: "Unlock KURB",
      subtitle: "Manage the entire secondhand designer clothing market from one place!",
    },
    emailCode: {
      subtitle: "Check your inbox for a magic code",
    },
  },
  signUp: {
    start: {
      title: "Join KURB",
      subtitle: "Make second hand second nature",
    },
  },
};

export default function NativeAwareClerkProvider({ children }: { children: ReactNode }) {
  // Capacitor exposes its platform synchronously in the WebView. Detecting it
  // here keeps static and ISR routes independent of request headers while
  // still disabling Clerk's standard-browser flow inside the native shell.
  const isNative = isNativeCapacitorApp();

  return (
    <ClerkProvider
      key={isNative ? "native" : "web"}
      standardBrowser={isNative ? false : undefined}
      ui={ui}
      appearance={appearance}
      localization={localization}
    >
      {children}
    </ClerkProvider>
  );
}
